import { KnowYourCustomerData } from '@blisspointmedia/bpm-types/dist/KnowYourCustomer';
import { getChannelSeriesColor, Neutral400 } from '../../utils/colors';
import {
  CUSTOMER_INSIGHTS_LEVELS_PRETTY_NAMES,
  CUSTOMER_INSIGHTS_ORDERED_LEVELS,
  CustomerInsightsFields
} from './customer-insights-constants';

// For some fields, "Alphabetical" sort is not literally alphabetical,
// but instead reflects a logical default ordering
export const getCustomerInsightsAlphabeticalSort = (
  fieldName: CustomerInsightsFields,
  data: KnowYourCustomerData[]
): KnowYourCustomerData[] => {
  const sortedData: KnowYourCustomerData[] = [];

  const ordering = CUSTOMER_INSIGHTS_ORDERED_LEVELS[fieldName];
  if (!ordering) {
    throw new Error(`No alphabetical ordering found for ${fieldName}`);
  }

  CUSTOMER_INSIGHTS_ORDERED_LEVELS[fieldName].forEach(dataName => {
    const found = data.find(val => val.levels === dataName);

    if (found) {
      const prettyName = CUSTOMER_INSIGHTS_LEVELS_PRETTY_NAMES[fieldName][dataName];
      if (prettyName) {
        found.levels = prettyName;
      }

      sortedData.push(found);
    }
  });
  return sortedData;
};

export const buildColorMap = (data: KnowYourCustomerData[]): Record<string, string> => {
  const map: Record<string, string> = {};
  for (let i = 0; i < data.length; i++) {
    const { levels } = data[i];

    let color;
    if (levels === 'Unknown') {
      color = Neutral400;
    } else {
      color = getChannelSeriesColor(i, true);
    }

    map[levels] = color;
  }
  return map;
};
